import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthShell, Field, FormError } from "../components/AuthShell";
import { api, errMsg } from "../lib/api";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Passwords don't match");
    setBusy(true); setErr("");
    try { await api.post("/auth/reset-password", { token: sp.get("token") || "", password: pw }); setDone(true); }
    catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="new password" subtitle="pick something you haven't used before.">
      {done ? (
        <div className="space-y-4">
          <div data-testid="reset-success-message" className="rounded-xl border border-[#ff3b91]/30 bg-[#ff3b91]/10 px-4 py-3 text-sm text-pink-100">Password updated. You can log in now.</div>
          <Link to="/login" className="btn-pink w-full" data-testid="reset-login-button">log in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field label="new password" type="password" minLength={8} data-testid="reset-password-input" value={pw} onChange={(e) => setPw(e.target.value)} required />
          <Field label="confirm password" type="password" minLength={8} data-testid="reset-password-confirm-input" value={pw2} onChange={(e) => setPw2(e.target.value)} required />
          <FormError msg={err} />
          <button disabled={busy} className="btn-pink w-full" data-testid="reset-submit-button">{busy ? "saving…" : "set password"}</button>
        </form>
      )}
    </AuthShell>
  );
}
